/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Submit_Review_Free_TitleInputs */

const en_directory_submit_review_free_title = /** @type {(inputs: Directory_Submit_Review_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free review`)
};

const zh_directory_submit_review_free_title = /** @type {(inputs: Directory_Submit_Review_Free_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费审核`)
};

/**
* | output |
* | --- |
* | "Free review" |
*
* @param {Directory_Submit_Review_Free_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_submit_review_free_title = /** @type {((inputs?: Directory_Submit_Review_Free_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Submit_Review_Free_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_submit_review_free_title(inputs)
	return zh_directory_submit_review_free_title(inputs)
});
export { directory_submit_review_free_title as "directory.submit.review.free_title" }